<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="title"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    width="300px"
  >
    <el-form label-width="60px" label-position="left">
      <el-form-item :label="$t('Menu.ChineseName')">
        <el-input v-model="form.chineseLabel" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('Menu.EnglishName')">
        <el-input v-model="form.englishLabel" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('Menu.Coding')">
        <el-input v-model="form.code" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('Menu.Icon')">
        <el-input v-model="form.icon" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('Menu.ModuleFile')">
        <el-input v-model="form.actions" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('Menu.H5Url')">
        <el-input v-model="form.url" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('Menu.ParentNode')">
        <el-input-number v-model="form.parentId" :min="0" :max="99999999" controls-position="right" :precision="0" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('Menu.Order')">
        <el-input-number v-model="form.orderIndex" :min="1" :max="99999999" controls-position="right" :precision="0" style="width: 200px" />
      </el-form-item>
      <el-form-item :label="$t('Menu.Type')">
        <el-select v-model="form.type" style="width: 200px">
          <el-option :label="$t('Menu.Module')" :value="2" />
          <el-option :label="$t('Menu.Component')" :value="1" />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="enterHandler">{{ $t('Menu.Save') }}</el-button>
      <el-button type="primary" @click="closeHandler">{{ $t('Menu.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import StrUtils from '@/utils/StrUtils'
import { getLoading } from '@/utils/utilBaseElement'
import * as sysMenuApi from '@/api/menu'

export default {
  name: 'SysMenuWindow',
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    sysMenu: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      form: {
        chineseLabel: '',
        englishLabel: '',
        code: '',
        icon: '',
        actions: '',
        url: '',
        parentId: 0,
        orderIndex: 1,
        type: 2
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (newVal) {
        Object.assign(this.form, this.sysMenu)
      } else {
        this.reSetForm()
      }
    }
  },
  methods: {
    enterHandler() {
      if (StrUtils.isEmpty(this.form.chineseLabel)) {
        this.$message.warning(this.$t('Menu.ChineseCanNotBeEmpty'))
        return
      }
      if (StrUtils.isEmpty(this.form.englishLabel)) {
        this.$message.warning(this.$t('Menu.EnglishCanNotBeEmpty'))
        return
      }
      if (StrUtils.isEmpty(this.form.code)) {
        this.$message.warning(this.$t('Menu.TheEncodingCanNotBeEmpty'))
        return
      }
      const loading = getLoading()
      sysMenuApi.save(this.form).then(resp => {
        this.$message.success(this.$t('Menu.SavedSuccess'))
        this.$emit('saveCallBack', resp.data)
        this.closeHandler()
      }).finally(() => loading.close())
    },
    closeHandler() {
      this.$emit('close')
    },
    reSetForm() {
      this.form = {
        chineseLabel: '',
        englishLabel: '',
        code: '',
        icon: '',
        actions: '',
        url: '',
        parentId: 0,
        orderIndex: 1,
        type: 2
      }
    }
  }
}
</script>

<style scoped>

</style>
